const roundNearest = (num, acc) => {
  if (acc < 0) {
    return Math.round(num * acc) / acc;
  }
  return Math.round(num / acc) * acc;
};

export default roundNearest;
